import React, {Component} from 'react'
import InlineCode from 'lib/struct/InlineCode'

import styles from './TemplateHelper.less'

export default class TemplateHelper extends Component {
    render() {
        const {variables, modifiers, custom_variables, className} = this.props

        const block_classes = [styles.templateHelper]
        if (className) {
            block_classes.push(className)
        }

        return (
            <div className={block_classes.join(' ')}>
                <div className={styles.templateHelper__wrapper}>
                    {variables && (
                        <div>
                            <Header>Переменные</Header>
                            {variables.map(item => (
                                <div key={item.variable} className={styles.templateHelper__variable}>
                                    <InlineCode>{item.variable}</InlineCode>
                                    {' - '}
                                    {item.description}
                                </div>
                            ))}
                        </div>
                    )}
                    {modifiers && (
                        <div>
                            <Header>Модификаторы</Header>
                            {modifiers.map(item => (
                                <div key={item.modifier} className={styles.templateHelper__variable}>
                                    <InlineCode>{item.modifier}</InlineCode>
                                    {' - '}
                                    {item.description}
                                </div>
                            ))}
                        </div>
                    )}
                    {custom_variables && (
                        Object.keys(custom_variables).map(plugin_name => (
                            <div key={plugin_name}>
                                <Header>{plugin_name}</Header>
                                {custom_variables[plugin_name].map(item => (
                                    <div key={item.variable} className={styles.templateHelper__variable}>
                                        <InlineCode>{item.variable}</InlineCode>
                                        {' - '}
                                        {item.description}
                                    </div>
                                ))}
                            </div>
                        ))
                    )}
                </div>
            </div>
        )
    }
}

export class Wrapper extends Component {
    render() {
        const {helper, children} = this.props

        return (
            <div className={styles.templateHelperWrapper}>
                {helper}
                {children}
            </div>
        )
    }
}

class Header extends Component {
    render() {
        const {children} = this.props

        return (
            <div className={styles.templateHelperHeader}>
                {children}
            </div>
        )
    }
}
